package com.klantenstop.web.pages.contact

import androidx.compose.runtime.Composable
import com.klantenstop.web.components.FacebookLink
import com.klantenstop.web.components.VisuallyHiddenH1
import com.materialkobweb.components.Spacer
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.klantenstop.web.components.layout.PageLayout
import com.klantenstop.web.components.layout.PageSeoConfig
import com.klantenstop.web.utils.Constants
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Page("/contact")
@Composable
fun ContactPage() {
    val breakpoint = rememberBreakpoint()

    PageLayout(
        modifier = Modifier.fillMaxSize(),
        title = "Neem contact op met het KlantenStop team",
        seo = PageSeoConfig.Managed(
            description = "Neem contact op met het KlantenStop team voor vragen over ons platform, suggesties, samenwerkingen of het melden van onjuiste bedrijfsinformatie.",
            indexable = true,
            breadcrumbLabel = "Contact",
        )
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint > Breakpoint.SM) 80.percent else 90.percent)
                .fillMaxHeight(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            VisuallyHiddenH1(text = "Neem contact op met het KlantenStop team")

            SpanText(
                modifier = Modifier
                    .textAlign(TextAlign.Center)
                    .fontSize(18.px)
                    .lineHeight(30.px)
                    .fillMaxWidth()
                    .maxWidth(Constants.SECTION_WIDTH.px)
                    .whiteSpace(WhiteSpace.PreWrap),
                text = "Gelieve er rekening mee te houden dat deze website niet bedoeld is om rechtstreekt een afspraak te maken met een huisarts of derden.\n\n" +
                        "Voor inhoudelijke vragen en opmerkingen, gelieve een mail te sturen naar: info@klantenstop.be\n\n" +
                        "KlantenStop wordt co-beheerd door C.B. Connect I.T."
            )

            Spacer(Modifier.height(24.px))

            SpanText(
                modifier = Modifier.fontSize(18.px),
                text = "Volg ons ook op social media:"
            )

            Spacer(Modifier.height(8.px))

            FacebookLink(fontSize = 18)
        }
    }
}
